import { getExtensionId } from '../config/extension';
import { isRealSuperAdmin } from './authSession';

const isDevelopmentHost = () => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname.toLowerCase();
  return host === 'localhost'
    || host === '127.0.0.1'
    || host === 'traffic-lite-front-end-staging.netlify.app';
};

export const syncPolicyPreviewDomain = (domain: string) => {
  if (!isDevelopmentHost() || !isRealSuperAdmin()) return;
  const chromeApi = (window as unknown as {
    chrome?: { runtime?: { sendMessage?: (...args: unknown[]) => void } };
  }).chrome;
  const sendMessage = chromeApi?.runtime?.sendMessage;
  if (!sendMessage) return;

  const normalized = String(domain || '').trim().toLowerCase();
  const message = {
    action: 'SET_POLICY_PREVIEW_DOMAIN',
    domain: !normalized || normalized === 'gmail.com' ? '' : normalized
  };
  const extensionId = getExtensionId();
  try {
    if (extensionId) sendMessage(extensionId, message, () => undefined);
    else sendMessage(message, () => undefined);
  } catch {
    // The staging extension is not installed in this browser.
  }
};
